<template>
    <div class="homeLink" @click="() => {navigate(`/module/${module[0]}${params}`)}">
        <div>
            <img :src="module[1].icons.drawer">
        </div>
        <p>{{ module[1].name[$i18n.locale] }}</p>
    </div>
</template>

<script>
export default {
    props: ['module'],
    computed: {
        params(){
            if(this.module[1].params){
                return '/' + this.module[1].params.join('/')
            }
            else {
                return ''
            }
        }
    },
    methods: {
        navigate(route){
            this.$emit('close')
            if(this.$route.path != route){
                this.$router.pushWithEvent(route)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .homeLink {
        display: inline-flex;
        flex-direction: column;
        width: 31vw;
        height: 31vw;
        color: black;
        background-color: $lightGrey;
        margin: 3vw;
        padding: 4%;
        text-align: center;
        justify-content: space-around;
        align-items: center;
        font-weight: bold;
        overflow-y: hidden;

        div {
            width: 50%;
            height: 50%;
            margin: 0 auto;
            img {
                display: block;
                object-fit: contain;
                width: 100%;
                height: 100%;
                margin-bottom: 4px;
            }
        }

        p {
            font-family: $titleFont;
            font-size: 14px;
            height: 30%;
            display: flex;
            align-items: center;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1280px) {

        .homeLink {
            width: 20vw;
            height: 20vw;
            margin: 2vw;
        }

    }

    @media screen and (min-width: 1024px) {
        .homeLink {
            width: 16vw;
            height: 16vw;
            margin: 1vw;
        }
    }
</style>